<template>
  <bita-modal
      id="commissionPaymentModal"
      :title="title"
      :modal-lg="true"
      :isLoading="isLoading"
      @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              name="amount"
              style="direction: ltr"
              label="مبلغ"
              rules="required"
              :has-thousand-seprator="true"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.amount"
          />

            <bita-input
                type="text"
                name="tracking_code"
                label="کد رهگیری"
                style="direction: ltr"
                rules="required"
                :validation-container-class="colWidth"
                input-class="form-control"
                v-model="dataForm.tracking_code"
            />

            <bita-input
                type="text"
                name="description"
                label="توضیحات"
                :validation-container-class="colWidth"
                input-class="form-control"
                v-model="dataForm.description"
            />
            <bita-bootbutton
                type="primary transaction"
                title="ذخیره"
                icon="fa fa-check"
                btn-width="150px"
                @click.native="handleSubmit()"
            />
          </div>
        </div>
      </bita-form>
      <bita-grid
          ref="grid"
          :columns="gridColumns"
          :read-data="readData"
          :server-paging="true"
          :batch="true"
          :resizable="true"
          :grid-server-side="true"
          :schema-total="'total'"
          :schema-data="'data'"
          :page-size="pageSize"
          :current-page="currentPage"
          :auto-bind="false"
      />
    </div>
  </bita-modal>
</template>
<script>
import {commissionPaymentApi, productApi} from "@/api/apiManagement.js";

export default {
  data() {
    return {
      colWidth: "col-lg-3 col-md-6 col-sm-6",
      isLoading: false,
      dataForm: {},
      user: {},
      pageSize: 10,
      currentPage: 1,
    };
  },
  computed: {
    title() {
      return `پرداختی هابه ${this.user.full_name}`;
    },
    gridColumns() {
      return [
        {
          field: "amount",
          title: "مبلغ",
          template: ({ amount }) => {
            let priceClass = "text-success";

            return (
                `<span class="${priceClass}">` +
                (amount ? this.$thousandSeprator(amount) : " - ") +
                `</span>`
            );
          },
        },
        {
          field: "tracking_code",
          title: "کد رهگیری",
          template: ({ tracking_code }) => (tracking_code ? tracking_code : "-"),
        },
        {
          field: "description",
          title: "توضیحات",
          template: ({ description }) => (description ? description : "-"),
        },
        {
          field: "created_at",
          title: "تاریخ",
          template: ({ created_at }) => this.$getJalaliDateTime(created_at),
        },
        {
          title: "عملیات",
          command: this.getGridColumns(),
          with: 120,
        },
      ];
    },
  },
  methods: {
    getGridColumns() {
      let commands = [];
      if (this.$acl.can("edit", "commission-payments")) {
        commands.push({
          text: "edit",
          click: this.edit,
          template: this.gridButtons.edit,
        });
      }
      if (this.$acl.can("delete", "commission-payments")) {
        commands.push({
          text: "delete",
          click: this.delete,
          template: this.gridButtons.delete,
        });
      }
      return commands;
    },
    init(user) {
      this.user = user;
      this.isLoading = true;
      this.$showModal("#commissionPaymentModal");
      this.loadData();
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;

      commissionPaymentApi
          .get({
            page_size: this.pageSize,
            page: this.currentPage,
            user_id: this.user.id
          })
          .then(({ data }) => {
            e.success(data.entity);
            this.$emit("on-reload");
          })
          .catch(() => {
            e.success([]);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.isLoading = true;
          if (this.dataForm.id) {
            commissionPaymentApi
                .update(this.dataForm.id, this.dataForm)
                .then(({ data }) => {
                  this.reset();
                })
                .finally(() => {
                  this.isLoading = false;
                  this.loadData();
                });
          } else {
            commissionPaymentApi
                .create({...this.dataForm, 'user_id': this.user.id})
                .then(({ data }) => {
                  this.reset();
                })
                .finally(() => {
                  this.isLoading = false;
                  this.loadData();
                });
          }

        }
      });
    },
    edit(e) {
      let item = this.$refs.grid.getSelectedGridRow(e);
      this.dataForm = {id: item.id, amount: item.amount, tracking_code: item.tracking_code, description: item.description}
    },
    delete(e) {
      let item = this.$refs.grid.getSelectedGridRow(e);
      this.$alert("question", `آیا از حذف ${item.tracking_code} اطمینان دارید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          commissionPaymentApi
              .delete(item.id)
              .then((res) => {
                this.$izitoast("success", "با موفقیت حذف شد", "موفق");
                this.loadData();
              })
              .finally(() => {
                this.isLoadingGrid = false;
              });
        }
      });
    },
    reset() {
      this.dataForm = {};
      this.$refs.form.reset();
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
    onCloseModal(e) {
      this.$emit("on-close");
      this.reset();
    },
    onModelChange(e) {
      // this.$refs.modelIDDropDown.emptyKendo()
      this.$emit("change-model-type", e);
    },
  },
};
</script>
<style scoped>
img {
  width: 75px;
  max-height: 120px;
}
.custom-file-label {
  padding: 0.5rem 4.2rem 0 0;
}
.center-align {
  text-align: center;
}
.btn-primary.transaction {
  margin: 25px auto 0 auto !important;
  height: 39px;
}
</style>
